<template>
  <div id="view-container">
    <a-modal
        v-model:open="popupWindow"
        title="选择用户来源"
        :footer="null"
    >
      <ul v-if="sharedUserList.length" style="max-height: 400px;overflow-y: auto">
        <li v-for="sharedUser in sharedUserList" style="display: flex;align-items: center;margin-top: 10px;padding: 5px 5px" id="shared-user-item" @click="importDataFrom(sharedUser.uid)">
          <div style="display: inline-block">
            <a-avatar :size="45" :style="'box-shadow: 3px 6px 6px rgba(0,0,0,.15);background-color: #eeeeee'" v-if="sharedUser" :src="`${domain}\\${sharedUser.avatar}`"/>
          </div>
          <div style="display: inline-block;margin-left: 10px">
            <span style="font-size: 16px;font-weight: bold">{{sharedUser.uname}}<a-tag color="green" v-if="sharedUser.roles.includes('ADMIN')" style="margin-left: 3px">管理员</a-tag></span><br>
            <span>{{sharedUser.signature}}</span>
          </div>
        </li>
      </ul>
    </a-modal>
    <div id="welcome">
      🎉欢迎进入方言地图后台数据维护中心
    </div>
    <div id="backend-button-container">
      <button><router-link to="/languages">🌏大方言区数据🌏</router-link></button>
      <button><router-link to="/dialects">💡方言片数据💡</router-link></button>
      <button><router-link to="/subdialects">🙋‍方言小片数据🙋‍</router-link></button>
      <button><router-link to="/accents">🎈口 音 数 据🎈</router-link></button>
      <button @click="importPublicData" style="color: white">📥导入公共数据📥</button>
      <button @click="deleteAllData" style="color: white">🗑️删除全部数据🗑️</button>

    </div>

  </div>

</template>

<script setup>
import {ref, onMounted, computed} from "vue"
import request, {domain} from "@/utils/request.js";
import {message} from "ant-design-vue";
let popupWindow=ref(false);
let sharedUserList=ref([])
const importPublicData=async ()=>{
  popupWindow.value=true;
  sharedUserList.value= (await request.get("/auth/shared")).data
}
const importDataFrom=async (uid)=>
{
  if(confirm("⚠️确定要导入该用户的数据吗？")) {
    try {
      await request.post(`/auth/shared/${uid}`)
      message.success("导入成功！")
    }
    catch (e)
    {
      message.error("导入失败！");
    }
  }
}
const deleteAllData=async ()=>{
  if(confirm("⚠️确定要清空全部数据？你应当知道这是不可逆的！")) {
    try {
      await request.delete(`/auth/data`)
      message.success("清空成功！")
    }
    catch (e)
    {
      message.error("清空失败！");
    }
  }
}
</script>

<style scoped>
  #view-container{
    width: 100vw;
    height: 100vh;
    background-color: rgba(225,250,225,80%);

  }
  #welcome{
    text-align: center;
    margin-top: 10%;
    /*background-color: #4a90e2;*/
    font-size: 32px;
    font-weight: bold;
    opacity: 0;
    transform: translateY(20px);
    animation: fadeUp 0.6s ease forwards;
  }
  #backend-button-container{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    /*background-color: #4a90e2;*/
    height: 300px;
    margin-top: 50px;
  }
  button
  {
    display: block;
    width: 200px;
    margin-top: 10px;
    opacity: 0;
    transform: translateY(20px);
    animation: fadeUp 0.7s ease forwards;
    background-color: rgb(76, 175, 80);
  }
  button:hover{
    scale: 105%;
  }
  @keyframes fadeUp {
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
  :deep(a){
    color: white;
    text-decoration: none;
  }
  #shared-user-item:hover{
    background-color: #eeeeee;
    cursor: pointer;
  }
</style>